import React, { useState } from 'react'
import Icon from 'components/Icon'
import { toColor } from 'utils'

const Stat = ({ title, name, icon, symbol, data: { current, currentText, previous, change, kpi } = {}, children }) => (
  <div title={title} className="px-4 py-5 sm:p-6 bg-white overflow-hidden shadow rounded-sm">
    <div className="flex items-center">
      <div className={`flex-shrink-0 rounded-sm p-3 ${toColor(name)}`}>
        <div className="h-6 w-6 text-white text-xl flex items-center justify-center">
          <Icon icon={icon} />
        </div>
      </div>
      <div className="ml-5 w-0 flex-1">
        <dt className="text-sm font-medium text-gray-500 truncate">
          { name }
        </dt>
        <dd className="flex items-baseline">
          <div className='flex gap-1'>
            {current &&
              <div className="text-2xl font-semibold text-gray-900">
                { current }
              </div>
            }
            {currentText &&
            <div className="text-xs text-gray-400 mt-auto">
              { currentText }
            </div>
            }
          </div>
          {typeof change !== 'undefined' && change !== null &&
            <div className={`flex ml-2 space-x-1 items-baseline text-sm font-semibold ${change > 0 ? 'text-positive' : 'text-negative'}`}>
              <Icon icon={change > 0 ? 'arrow-up' : 'arrow-down'} className="mt-auto text-xs" />
              <span>{ change }{ symbol }</span>
            </div>
          }
          {typeof kpi !== 'undefined' && kpi !== null &&
            <div className={`ml-2 space-x-1 items-baseline text-sm font-semibold ${kpi > current ? 'text-positive' : 'text-negative'}`}>
              <span>/{ kpi }{ symbol }</span>
            </div>
          }
        </dd>
        {children &&
          <div>
            {children}
          </div>
        }
      </div>
    </div>
  </div>
)

export default Stat
